export enum Languages {
    EN = 'en',
    KO = 'ko',
}
